// extracted by css-extract-rspack-plugin
export default {"Media":"Media-module__Media__PTotfmG"};